import React from "react";

import { Tour as AntTour, TourProps as AntTourProps } from "antd";

export type TourProps = AntTourProps & {
  dataTestId?: string;
};

export const Tour = ({ dataTestId, ...props }: TourProps) => <AntTour data-testid={dataTestId} {...props} />;
